/**
 * Sidebar Sticky on Scroll End
 * Makes sidebars stick to the bottom when their content reaches the bottom of viewport
 */

export function initSidebarSticky() {
    const sidebars = document.querySelectorAll('.sidebar');
    
    if (!sidebars.length) {
        return;
    }

    // Throttle function for performance
    function throttle(func, delay) {
        let lastCall = 0;
        return function(...args) {
            const now = Date.now();
            if (now - lastCall >= delay) {
                lastCall = now;
                func(...args);
            }
        };
    }

    function checkSidebarPosition() {
        sidebars.forEach((sidebar) => {
            const viewportHeight = window.innerHeight;
            
            // Get the last child element in the sidebar (the actual content bottom)
            const children = sidebar.children;
            const lastChild = children[children.length - 1];
            
            if (!lastChild) {
                return;
            }
            
            const isCurrentlySticky = sidebar.classList.contains('is-sticky');
            
            // Temporarily remove sticky to get true position
            if (isCurrentlySticky) {
                sidebar.classList.remove('is-sticky');
            }
            
            const sidebarRect = sidebar.getBoundingClientRect();
            const lastChildRect = lastChild.getBoundingClientRect();
            
            // Calculate total sidebar content height
            const sidebarContentHeight = lastChildRect.bottom - sidebarRect.top;
            const isSidebarShorterThanViewport = sidebarContentHeight < viewportHeight;
            
            // Decide whether to make sticky
            const shouldBeSticky = lastChildRect.bottom <= viewportHeight;
            
            if (shouldBeSticky) {
                // Remove both classes first
                sidebar.classList.remove('is-sticky', 'is-sticky-top');
                
                if (isSidebarShorterThanViewport) {
                    sidebar.classList.add('is-sticky-top');
                } else {
                    sidebar.classList.add('is-sticky');
                }
            } else if (isCurrentlySticky || sidebar.classList.contains('is-sticky-top')) {
                // Only remove sticky if we've scrolled back to the top enough
                // Check if the sidebar top is visible (user scrolled back up)
                if (sidebarRect.top > 0) {
                    sidebar.classList.remove('is-sticky', 'is-sticky-top');
                } else {
                    if (isSidebarShorterThanViewport) {
                        sidebar.classList.add('is-sticky-top');
                    } else {
                        sidebar.classList.add('is-sticky');
                    }
                }
            }
        });
    }

    // Initial check
    checkSidebarPosition();

    // Listen to scroll events with throttling for performance
    const throttledCheck = throttle(checkSidebarPosition, 16); // ~60fps
    window.addEventListener('scroll', throttledCheck);
    window.addEventListener('resize', throttledCheck);
}

